import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { MuiTypography } from "..";
import { MuiCheckboxWrapper } from "./MuiCheckbox.style";

interface MuiCheckboxProps extends CheckboxProps {
  checkboxLabel: string;
  onCheckedChange?: (checked: boolean) => void;
  hideLabel?: boolean;
}
export const MuiCheckbox = ({
  checkboxLabel,
  onCheckedChange,
  checked,
  id,
  hideLabel = false,
  ...rest
}: MuiCheckboxProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckedChange?.(event.target.checked);
  };

  return (
    <MuiCheckboxWrapper>
      <Checkbox
        checked={checked}
        data-testid={id}
        onChange={handleChange}
        color="primary"
        inputProps={{
          "aria-label": checkboxLabel,
        }}
        {...rest}
      />
      <MuiTypography aria-hidden variant="h3" className="text">
        {hideLabel ? "" : checkboxLabel}
      </MuiTypography>
    </MuiCheckboxWrapper>
  );
};
